import { render, staticRenderFns } from "./detailWrapper.vue?vue&type=template&id=5c6bc839"
import script from "./detailWrapper.vue?vue&type=script&lang=js"
export * from "./detailWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports